import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Result, Button, Space } from "antd";
import { PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";
import IdCard, { buildTelHref, buildMapsHref } from "../../components/Common/IdCard";
import { BASE_URL } from "../../components/Common/AppConfig";

const PublicCard = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${BASE_URL}/address/${id}`);
        const result = await response.json();
        if (result && result.status && result.data) {
          setUser(result.data);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !user) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Result status="404" title="Not Found" subTitle="Sorry, this member card could not be found." />
      </div>
    );
  }

  const telHref = buildTelHref(user.phone);
  const mapsHref = buildMapsHref(user);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        padding: "24px 16px",
        background: "#f7efe9",
        gap: 20,
      }}
    >
      <IdCard user={user} />
      <Space size="middle" wrap style={{ justifyContent: "center" }}>
        {telHref && (
          <Button type="primary" size="large" icon={<PhoneOutlined />} href={telHref}>
            Call
          </Button>
        )}
        {mapsHref && (
          <Button size="large" icon={<EnvironmentOutlined />} href={mapsHref} target="_blank" rel="noopener noreferrer">
            Open in Google Maps
          </Button>
        )}
      </Space>
    </div>
  );
};

export default PublicCard;
